import { render, staticRenderFns } from "./BinCollectionScheduleCompact.vue?vue&type=template&id=0a219e30&"
import script from "./BinCollectionScheduleCompact.vue?vue&type=script&lang=js&"
export * from "./BinCollectionScheduleCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports